import { z } from 'zod';
import { getFullName } from '../../utils/name.ts';

export const platoUserDtoSchema = z
    .object({
        id: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        email: z.string(),
        preferredLanguage: z.string().nullish(),
    })
    .transform((data) => ({
        ...data,
        preferredLanguage: data.preferredLanguage ?? undefined,
        fullName: getFullName(data.firstName, data.lastName),
    }));

export type PlatoUserDTO = z.infer<typeof platoUserDtoSchema>;
